// extracted by mini-css-extract-plugin
export default {"header__container":"LoginPage_header__container__DvKpp","header__logo-box":"LoginPage_header__logo-box__hgGL-"};